import { render, staticRenderFns } from "./TabDefault.vue?vue&type=template&id=75446c8a&"
import script from "./TabDefault.vue?vue&type=script&lang=js&"
export * from "./TabDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports